import { useIsLoggedIn } from '@core-frontend/core-frontend';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { AppRoutes } from '../AppRoutes';

const UnauthenticatedGuard = () => {
  // const { isLoggedIn } = useAuth();
  const isLoggedIn = useIsLoggedIn();
  const location = useLocation();

  if (isLoggedIn) {
    return <Navigate to={AppRoutes.HOME} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default UnauthenticatedGuard;
